// extracted by mini-css-extract-plugin
export default {"root":"styles_root__vrKJP","editable":"styles_editable__RBs7o","edit-actions":"styles_edit-actions__SsHI-","editActions":"styles_edit-actions__SsHI-","icon":"styles_icon__EzxKX"};